import { useEffect } from "react";
import "./AtivarDesvioEditarModal.css";

export default function AtivarDesvioEditarModal({ open, label, onClose, onConfirm }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "Enter") onConfirm?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose, onConfirm]);

  if (!open) return null;

  return (
    <div className="dveam-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className="dveam-modal" role="dialog" aria-modal="true" aria-label="Ativar item">
        <header className="dveam-header">
          <h3 className="dveam-title">Ativar</h3>
          <button type="button" className="dveam-close" aria-label="Fechar" onClick={onClose}>
            ×
          </button>
        </header>

        <div className="dveam-body">
          Deseja <strong>ativar</strong> "{label || "este item"}"?
        </div>

        <footer className="dveam-footer">
          <button type="button" className="dveam-btn dveam-btn--ghost" onClick={onClose}>
            Cancelar
          </button>
          <button type="button" className="dveam-btn dveam-btn--primary" onClick={onConfirm}>
            Ativar
          </button>
        </footer>
      </div>
    </div>
  );
}
